<template lang="html">

  <section class="app-header" :showofertas="showofertasmenu">

    <div class="top">
      <div class="container row-end">
        <h3 class="nombre-usuario row-center">
          <router-link :to="$t('enlaces.micv')">Hola, {{name}}</router-link>
        </h3>
        <router-link class="mi-cv" :to="$t('enlaces.micv')">Mi cv</router-link>
        <router-link class="cerrar-sesion" :to="$t('enlaces.logout')">Cerrar sesión</router-link>
      </div>
    </div>


    <div class="bottom">
      <div class="container row-between">
        <router-link class="logo" :to="$t('enlaces.home')"><img src="@/assets/img/logo-uni.svg" alt="Logo">
        </router-link>
        <div class="row-start">
          <a class="ofertas" @click="showofertasmenu = !showofertasmenu">Ofertas</a>
          <a target="_blank" href="https://www.esic.edu/empleabilidad/recursos">Recursos</a>
          <a target="_blank" href="https://www.esic.edu/alumni/agenda">Eventos</a>
        </div>
      </div>
    </div>

    <div class="bottom submenu" :show="showofertasmenu">
      <div class="container row-end">
        <router-link :to="$t('enlaces.ofertas')">Ofertas ESIC</router-link>
        <router-link :to="$t('enlaces.oportunidadesinternacionales')">Portales globales</router-link>
        <router-link :to="$t('enlaces.miscandidaturas')">Mis candidaturas</router-link>
      </div>
    </div>

  </section>

</template>

<script lang="js">

  import { mapActions, mapGetters } from 'vuex';

  import router from '@/router';

  export default {
    name: 'app-header',
    data() {
      return {
        showofertasmenu: false
      }
    },
    watch: {
      '$route'() {
        this.showofertasmenu = false;
      }
    },
    computed: {
      ...mapGetters({
        name: 'getName'
      })
    },
    methods: {
      ...mapActions(['requestLogout']),
      logout() {
        this.requestLogout().then(() => {
          router.push({ name: 'login' })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/css/colors.scss';
</style>


// WEBPACK FOOTER //
// src/components/parts/header.vue